import { Component, Input } from '@angular/core';
import { FlightSegmentSch } from '../models/OTAAirScheduleResponse';
import { TicketResponse } from '../models/Ticket';

export type ContinuousItinerarySegment = FlightSegmentSch | TicketResponse;

interface ItinerarySegmentView {
  originCode: string;
  destinationCode: string;
  departureTime: string;
  arrivalTime: string;
  originCity: string;
  destinationCity: string;
  duration: string;
  arrivesNextDay: boolean;
}

@Component({
  selector: 'app-continuous-itinerary',
  templateUrl: './continuous-itinerary.component.html',
  styleUrls: ['./continuous-itinerary.component.scss'],
  standalone: false
})
export class ContinuousItineraryComponent {
  @Input() segments: readonly ContinuousItinerarySegment[] = [];

  get viewSegments(): ItinerarySegmentView[] {
    return this.segments.map(segment => this.toViewSegment(segment));
  }

  get connectionCount(): number {
    return Math.max(this.segments.length - 1, 0);
  }

  get accessibleLabel(): string {
    const itinerary = this.viewSegments;
    if (itinerary.length === 0) return 'Itinerário sem trechos';

    return [
      itinerary[0].originCode,
      ...itinerary.map(segment => segment.destinationCode)
    ].join(' para ');
  }

  private toViewSegment(segment: ContinuousItinerarySegment): ItinerarySegmentView {
    if (this.isFlightSegment(segment)) {
      return {
        originCode: segment.originLocationCode,
        destinationCode: segment.destinationLocationCode,
        departureTime: this.toTime(segment.departureDateTime),
        arrivalTime: this.toTime(segment.arrivalDateTime),
        originCity: segment.originCityName,
        destinationCity: segment.destinationCityName,
        duration: segment.duration,
        arrivesNextDay: segment.arrivalDayDiffDepartureDay
      };
    }

    return {
      originCode: segment.departure,
      destinationCode: segment.arrival,
      departureTime: this.toTime(segment.departureDateLt),
      arrivalTime: this.toTime(segment.arrivalDateLt),
      originCity: '',
      destinationCity: '',
      duration: '',
      arrivesNextDay: this.isDifferentDay(segment.departureDateLt, segment.arrivalDateLt)
    };
  }

  private isFlightSegment(segment: ContinuousItinerarySegment): segment is FlightSegmentSch {
    return 'originLocationCode' in segment;
  }

  private toTime(value: string): string {
    return value?.length >= 16 ? value.slice(11, 16) : value;
  }

  private isDifferentDay(departure: string, arrival: string): boolean {
    return departure?.slice(0, 10) !== arrival?.slice(0, 10);
  }
}
